module.exports = __webpack_public_path__ + "img/noOpenCity.746da974.png";